import type { QuoteCardData } from "../types";

export function QuoteCard({ data }: { data: QuoteCardData }) {
	const isSerif = data.variant === "serif";

	return (
		<div className="group border-ivory/5 bg-dark-accent hover:border-gold/30 relative z-10 overflow-hidden border p-8 transition-all duration-500">
			<div className="mb-6 flex items-center gap-2">
				<span className="material-symbols-outlined text-gold text-sm">
					{data.icon}
				</span>
				<span className="text-gold text-[10px] font-medium tracking-widest uppercase">
					{data.category}
				</span>
			</div>

			{isSerif ? (
				<p className="font-display text-ivory mb-6 text-base leading-relaxed italic">
					{data.quote}
				</p>
			) : (
				<blockquote className="font-display mb-6 text-xl leading-relaxed italic">
					{data.quote}
				</blockquote>
			)}

			<div className="flex items-center justify-between">
				<span className="text-ivory/40 text-[11px] font-light tracking-widest uppercase">
					{data.attribution}
				</span>
			</div>
		</div>
	);
}
